module.exports = __webpack_public_path__ + "img/qa.5393ff29.svg";